import { atom } from "jotai";
import { ASSET_APP_IDS } from "@zapier/canvas-constants";

import { defaultNodesAtom } from "./defaultNodesAtom";

const isChatbotNode = (appId: string = "") =>
  appId.includes(ASSET_APP_IDS.CHATBOTS);

export const numberOfUniqueChatbotNodesAtom = atom((get) => {
  const nodes = get(defaultNodesAtom);

  const chatbotNodes = nodes.filter(
    (node) =>
      isChatbotNode(node?.data?.services?.[0]?.currentImplementation?.id) &&
      node.data.chatbotId,
  );

  // Get unique chatbot IDs
  const uniqueChatbotIds = new Set(
    chatbotNodes.map((node) => node.data.chatbotId),
  );

  return uniqueChatbotIds.size;
});

numberOfUniqueChatbotNodesAtom.debugLabel = "numberOfUniqueChatbotNodesAtom";
